
<table class="table">
  <thead>
    <tr class="headers">
      <th class="col-standar">Última interacción</th>
      <th class="col-standard">Curso</th>
      <th class="col-tribu">Tribu</th>
      <th class="col-standard">Comentarios </th>
      <!-- <th class="col-standard">¿Siguiendo?</th> -->
      <th class="col-standard">Status</th>
      <!-- <th class="col-standard">Acciones</th> -->
    </tr>
  </thead>
  <tbody>
      <ng-content></ng-content>
  </tbody>
</table>
